import React, { useEffect, useState } from 'react'
import { AppContextProvider } from "./components/AppContext";
import debounce from 'lodash.debounce'
import Grid from './components/Grid'
import MessageBar from './components/MessageBar'
import Modal from './components/Modal'
import constants from './utils/constants'

const App = () => {
  const [height, setHeight] = useState(window.innerHeight)

  useEffect(() => {
    const recalculateHeight = () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      setHeight(window.innerHeight)
    }

    recalculateHeight()

    window.addEventListener('resize', debounce(recalculateHeight, 100))

    return () => {
      window.removeEventListener('resize')
    }
  }, [])

  return (
    <AppContextProvider>
      <Grid/>
      <MessageBar/>
      <div className="debug">v{constants.version} | height: {height}</div>
      <Modal/>
    </AppContextProvider>
  )
}

export default App
